<template>
  <div v-if="visible">
    <b-button @click="showModal = true" variant="primary">
      {{$t('navigation.download.label')}}
      <i v-show="busy" class="fa fa-spinner fa-spin"></i>
    </b-button>
    <b-modal v-model="showModal" :ok-disabled="!usage || !downloadType" @ok="download"
             :title="$t('navigation.download.label')" size="lg">
      <p>{{$t('navigation.download.text')}}</p>
      <div class="form-group">
        <b-form-radio-group v-model="usage" stacked>
          <b-form-radio value="research">{{$t('navigation.download.usage_options.research')}}</b-form-radio>
          <b-form-radio value="teaching">{{$t('navigation.download.usage_options.teaching')}}</b-form-radio>
          <b-form-radio value="both">{{$t('navigation.download.usage_options.both')}}</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="form-group">
        <label class="form-label">{{$t('navigation.download.details.label')}}</label>
        <input v-model="details" class="form-control" :placeholder="$t('navigation.download.details.placeholder')"/>
      </div>
      <div class="form-group">
        <label class="form-label">{{$t('navigation.download.download_label')}}</label>
        <b-form-radio-group v-model="downloadType" stacked>
          <b-form-radio :value="{type: 'application/zip', textOnly: true, excel: false}">
            {{$t('navigation.download.download_options.simple')}}
          </b-form-radio>
          <b-form-radio :value="{type: 'application/zip', textOnly: false, excel: false}">
            {{$t('navigation.download.download_options.full')}}
          </b-form-radio>
          <b-form-radio :value="{type: 'text/csv', textOnly: false, excel: true}">
            <ncs-label @click.native="downloadType = {type: 'text/csv', textOnly: false, excel: true}"
                       id="navigation.download.download_options.excel-csv" class="mb-0" style="font-size: 17px"/>
          </b-form-radio>
          <b-form-radio :value="{type: 'text/csv', textOnly: false, excel: false}">
            {{$t('navigation.download.download_options.csv')}}
          </b-form-radio>
        </b-form-radio-group>
      </div>
      <p v-html="$t('navigation.download.conditions_text', {terms: './terms'})"></p>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <b-button :disabled="!usage || !downloadType" variant="primary ml-auto mr-auto" @click="ok()">
          {{$t('navigation.download.modal_button')}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import {mapState, mapGetters} from 'vuex'
  import saveAs from 'file-saver'

  export default {
    data() {
      return {
        showModal: false,
        busy: false,
        usage: null,
        details: null,
        downloadType: null
      }
    },
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'navigation',
        completed: s => s.api.executionState === 'completed',
        resultType: s => s.api.resultType,
        result: s => s.api.result
      }),
      ...mapGetters({query: 'api/buildQuery'})
    },
    methods: {
      download() {
        this.busy = true
        this.$http({
          method: 'post',
          url: './texts_file',
          headers: {Accept: this.downloadType.type},
          responseType: 'arraybuffer',
          data: {
            ...this.query,
            options: {
              textOnly: this.downloadType.textOnly,
              excel: this.downloadType.excel,
              usage: this.usage,
              details: this.details
            }
          }
        }).then(r => {
          saveAs(
              new Blob([r.data], {type: r.headers['content-type']}),
              r.headers['content-disposition'].match(/attachment; filename="(.+)"/)[1]
          )
          this.$ga.page(`/search/navigation/download`)
          this.busy = false
        })
      }
    }
  }
</script>
